import { schedularTherapistFilterAction } from 'src/redux/actions/constant';
const initialState: object = {
  PT: [],
  OT: [],
  SLP: [],
};

export const getAllFilteredTherapistsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case schedularTherapistFilterAction.SET_THERAPIST_FILTER_IN_SCHUDLAR: {
      const { discipline, therapists } = action.payload;
      return {
        ...state,
        [discipline]: therapists,
      };
    }

    case schedularTherapistFilterAction.RESET_THERAPIST_FILTER_IN_SCHUDLAR: {
      const { discipline } = action.payload;
      return {
        ...state,
        [discipline]: [],
      };
    }
    default:
      return state;
  }
};
